import { v4 as uuidv4 } from 'uuid';
import appStoreBadge from '../assets/app-store-badge.svg';
import googlePlayBadge from '../assets/google-play-badge.png';
// This module is generated by the genversion tool as a part of the build process
// eslint-disable-next-line import/extensions
import { version } from '../../lib/version'; // eslint-disable-line import/no-unresolved

export const consts = {
  PAGE_SIZE: 10,
  MES_HISTORY_SIZE: 10,
  CHAT: 'CHAT',
  CALL: 'CALL',

  USER_INFO_TAB: 'User Info',
  CALL_TAB: 'Call with user',
  CALL_HISTORY_TAB: 'Call history',

  THREAD: {
    IS_CLIENT: 0,
    IS_PRO: 1,
  },
};

export const OS = {
  ANDROID: 'Android OS',
  IOS: 'iOS',
};

export const LOCAL_STORAGE = {
  ACTIVATION: 'ACTIVATION',
  PATH_NAME: 'pathName',
  REFRESH_TOKEN: 'REFRESH_TOKEN',
  USER_AUTH: 'USER_AUTH',
  USER_DATA: 'USER_DATA',
  UUID: 'uuid',
};

export const EN = 'en-us';
export const RU = 'ru';
export const IT = 'it-it';
export const ES = 'es-es';
export const PL = 'pl';
export const AE = 'ar-ae';
export const PT = 'pt-br';
export const DE = 'de-de';
export const FR = 'fr-fr';

export const langs = {
  [EN]: {
    code: 'en',
    lang: EN,
    name: 'eng',
    emoji: '🇬🇧',
  },
  [RU]: {
    code: 'ru',
    lang: RU,
    name: 'рус',
    emoji: '🇷🇺',
  },
  [IT]: {
    code: 'it',
    lang: IT,
    name: 'ita',
    emoji: '🇮🇹',
  },
  [ES]: {
    code: 'es',
    lang: ES,
    name: 'esp',
    emoji: '🇪🇸',
  },
  [PL]: {
    code: 'pl',
    lang: PL,
    name: 'pol',
    emoji: '🇵🇱',
  },
  [AE]: {
    code: 'ar',
    lang: AE,
    name: 'ar',
    emoji: '🇦🇪',
  },
  [PT]: {
    code: 'pt',
    lang: PT,
    name: 'pt',
    emoji: '🇧🇷',
  },
  [DE]: {
    code: 'de',
    lang: DE,
    name: 'de',
    emoji: '🇩🇪',
  },
  [FR]: {
    code: 'fr',
    lang: FR,
    name: 'fr',
    emoji: '🇫🇷',
  },
};

export const labelsGA = {
  downloadAppClick: 'Clicked Download App',
};

export const activityTypes = {
  call: 'Call on',
  callMissed: 'Missed call on',
  callFailed: 'Failed call on',
  im: 'Message on',
  uim: 'New message on',
  om: 'Outgoing message on',
  shortlisted: 'Shortlisted on',
  callDeclined: 'Call declined on ',
  callWithdrawn: 'Call withdrawn on ',
  callProBusy: 'Call pro busy on',
  callDisconnected: 'Call disconnected on',
  callNoAnswer: 'Call no answer on',
  callActive: 'Call active on',
  callTerminated: 'Call terminated on',
  chatError: 'Message error on',
};

export const chatBtns = {
  decline: 'Decline',
  pickUp: 'Pick up',
  textMe: 'Text me',
  cancel: 'Cancel',
  cancelCall: 'Cancel call',
  finish: 'Hang up',
  next: 'Next pro',
  control: {
    speaker: 'speaker',
    video: 'video',
    mute: 'mute',
    fullScreen: 'full-screen',
    screenSharing: 'screen-sharing',
  },
};

export const timeouts = {
  autoRejectTimeout: 25000,
  autoFinishCallTimeout: 60000,
  finishOnXMPPConnectionLostTimeout: 50000,
};

export const statuses = {
  SENT: 'Sent',
  DELIVERED: 'Delivered',
  READ: 'Read',
  FAILED: 'Failed',
};

/* export const branchIoKeys = {
  dev: 'key_test_fmIi9IeSnXeHJsULJk5Xebldqsjhpw6T',
  prod: 'key_live_hcHm1UgQh2mQQALMLl3aMojlrrjmoA5w',
}; */

export const ENVIRONMENTS = {
  DEVELOPMENT: 'development',
  PRODUCTION: 'production',
};


export const appVersion = version;

export const USER_AUTH = 'USER_AUTH';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const ACTIVATION = 'ACTIVATION';

export const BRANCH_IO_REF_TYPES = {
  RESET_PASSWORD: 'RESET_PASSWORD',
};

export const TOKEN_TYPES = {
  RESET_PASSWORD: 'RESET_PASSWORD',
};

/**
 * @desc Timeout to disconnection in ms
 *
 * @type {number}
 */
export const DISCONNECT_TIMEOUT_MS = 20 * 1000;

/**
 * @desc Timeout to reconnection in ms
 *
 * @type {number}
 */
export const RECONNECT_TIMEOUT_MS = 2 * 1000;

/**
 * @desc Timeout to video connection in ms
 *
 * @type {number}
 */
export const VIDEO_PLAYING_TIMEOUT_MS = 1000;

/**
 *
 * @desc Mobile applications list
 *
 * @type {{os: string, link: string, id: string, imgSrc: string}[]}
 */
export const APPS_LIST = [
  {
    id: uuidv4(),
    imgSrc: appStoreBadge,
    link: 'https://apps.apple.com/us/app/telmie/id1345950689',
    os: OS.IOS,
  },
  {
    id: uuidv4(),
    imgSrc: googlePlayBadge,
    link: 'https://play.google.com/store/apps/details?id=com.starcloud.telmie&hl=en',
    os: OS.ANDROID,
  },
];

/**
 * @desc Up to this duration user status is displaying with formatted time since last visit'
 *
 * @type {number}
 */
export const MAX_LAST_VISIT_HOURS = 24;

export const FULL_DATE_FORMAT = 'yyyy/LL/dd';

export const DATE_FORMAT = 'dd.LL';

export const TIME_FORMAT = 'HH.mm';

export const TIME_FORMAT_COLON = 'HH:mm';

export const EVENT_BUS_EVENTS = {
  PRESENCE_CHANGED_TO_ONLINE: 'presenceChangedToOnline',
  PRESENCE_CHANGED_TO_AWAY: 'presenceChangedToAway',
};

export const USERS_ERROR_CODES = {
  PRO_IS_NOT_AVAILABLE: 116,
};



// WEBPACK FOOTER //
// ./utils/consts.js